var focusableElements = new Set(["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"]);

function isElementKeyboardAccessible(element) {
  return focusableElements.has(element.tagName) || element.tabIndex !== -1;
}

export { isElementKeyboardAccessible };